<template>
  <div class="nameChange">
    <div class="uploadPage_toptitle">
      <div class="uploadPage_toptitlebox">
        <van-icon class="uploadPage_back" name="arrow-left" @click="backClick" />
        <div class="uploadPage_title">修改昵称</div>
        <van-icon name="close" v-show="
          $store.state.system == 'android' &&
          applets != 'xcx' &&
          !$store.state.isXcx &&
          $store.state.isInGame
        " @click="closeCommunity" />
      </div>
    </div>
    <div class="nameChange_content">
      <div class="nameChange_content_inoutbox">
        <van-field v-model="nameText" maxlength="20" />
      </div>
      <div class="nameChange_content_right">
        <div class="nameChange_close" @click="clearName"></div>
        <div class="nameChange_btn" @click="submitName">完成</div>
      </div>
    </div>
  </div>
</template>
<script>
//此组件暂时没用，页面内容放在了上级组件中
import get from '../../../../api/get';
import qs from 'qs';
import * as _code from '../../../../utils/code';
import { Toast } from 'vant';
export default {
  name: 'nameChange',
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  mounted() {
    console.log(this.name);
  },
  data() {
    return {
      applets: window.user.weixcode ? "xcx" : "",
      nameText: this.name
    };
  },
  methods: {
    clearName() {
      this.nameText = '';
    },
    submitName() {
      if (this.nameText == '') {
        Toast('用户名不能为空');
        return;
      }
      let obj = {
        newNickname: this.nameText
      };
      get.nickname(qs.stringify(obj)).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          Toast('修改成功');
          this.$emit('cancelMethod');
        } else {
          if (data.code == 2002) {
          } else {
            this.errorMessage(data);
          }
        }
      });
    },
    backClick() {
      this.$emit('cancelMethod');
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>
<style scoped></style>